import { fork, all } from 'redux-saga/effects';

import { user } from './user/actions';
import { exchageOrders } from './orders/actions';
import { instantExchangeOrders } from './instantExchange/actions';
import { wallets } from './wallets/actions';
import { margin } from './margin/actions';
import { userHotTransactions } from './transactions/actions';
import { userLoginHistory } from './loginHistory/actions';
import { userSecurity } from './security/actions';

export function* profile() {
  yield all([
    fork(user),
    fork(exchageOrders),
    fork(instantExchangeOrders),
    fork(userHotTransactions),
    fork(wallets),
    fork(margin),
    fork(userLoginHistory),
    fork(userSecurity),
  ]);
}
